(ns frontend.ux-overhaul.nev.default-components
  (:require
   [ui.util :as uu]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [frontend.bootstrap.components :as rbs]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
   [frontend.ux-overhaul.nev.events :as nev-events]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]))

(defn section-layout
  [{:keys [nev-section action-button hide-title?]} & contents]
  (let [state-atom (r/atom {})]
    (fn [{:keys [nev-section]} & contents]
      (let [{:keys [nev-section/title nev-section/id]} nev-section
            {:keys [hover?]} @state-atom]

        [:div
         {:id    (str id)
          :style {:padding-top   "30px"
                  :padding-right "20px"}}

         [:div.nev-section-container
          {:on-mouse-enter #(swap! state-atom assoc :hover? true)
           :on-mouse-leave #(swap! state-atom dissoc :hover?)
           :style          {:position      "relative"
                            :padding       "20px"
                            :border        "1px solid #bfbfbf"
                            :border-radius "3px 30px 3px 30px"
                            :background    "white"}}

          (when-not hide-title?
            [:div
             {:style {:display         "flex"
                      :justify-content "space-between"}}
             [:h4
              {:style {:font-size     "22px"
                       :margin-bottom "15px"}}
              title]

             (when action-button
               action-button)])

          ; Todo - enable later
          #_[:div
             {:style {:position "absolute"
                      :top      "0px"
                      :bottom   "0px"
                      :right    "-22px"
                      :height   "100%"
                      :width    "22px"}}

             (when hover?
               [:div
                {:style {:margin-top     "20px"
                         :display        "flex"
                         :flex-direction "column"}}

                [:button
                 {:on-click (fn []
                              (js/console.log "Open entity editor"))}
                 [:i.fal.fa-pencil]]

                [:button
                 {:on-click (fn []
                              (let [viewed-entity-id (-> (routing/view)
                                                         :route-params
                                                         :id
                                                         (js/parseInt))]
                                (rf/dispatch [::nev-events/open-view-configuration (routing/view)])))}
                 [:i.fal.fa-cog]]])]

          [:<>
           contents]]]))))


(defn section-action-dropdown
  [{:keys [actions label]}]
  (let [primary-entity-id nil
        primary-entity (get @session/entities primary-entity-id)
        primary-entity-type (:entity/type primary-entity)
        value-creation? (and (session/value-creation?)
                             (or (= primary-entity-type :entity.type/investor)
                                 (and (= primary-entity-type :entity.type/holding)
                                      (some->> primary-entity
                                               :holding/target-asset
                                               (session/get-entity)
                                               :entity/type
                                               (= :entity.type/company)))))

        open-modal (fn [entity-type]
                     (modals/open-modal! activity-entity-editor/modal-key
                                         {:new-entity-type  entity-type
                                          :viewed-entity-id primary-entity-id}))]
    [:ul {:class-name (fu/cs "create-dropdown-container pb-1")}
     [dropdown-menu/view
      {:trigger [dropdown-menu/button-trigger-open
                 [:i.fas.fa-ellipsis-v]]
       :items   (->> actions
                     (map-indexed
                      (fn [idx action]
                        (let [{:keys [label icon ord tooltip-text dropdown-color divider divider?
                                      on-select disabled? toggle-item? checked? on-checked-change]}
                              action]
                          {:label          label
                           :icon-class     (uu/cm "fal" icon)
                           :separator?     divider?
                           :disabled?      (boolean disabled?)
                           :section-label? (true? divider)
                           :on-click       on-select})))
                     (doall))}]]))



;; Multimethods for rendering different types of sections and blocks in nev

(defmulti render-nev-block
  (fn [{:keys [nev-block]}]
    (:nev-block/type nev-block)))

(defmethod render-nev-block :default
  [_]
  [:div " "])

(defmulti render-nev-section
  (fn [{:keys [nev-section]}]
    (:nev-section/type nev-section)))

(defmethod render-nev-section :default
  [{:keys [nev-section view-args]}]
  (let [{:keys [nev-section/id nev-section/blocks]} nev-section]
    [section-layout
     {:nev-section nev-section}
     (if (seq blocks)
       [:div
        (->> blocks
             (map-indexed (fn [index nev-block]
                            ^{:key (str "nev-section-" id "-block-" index)}
                            (render-nev-block {:block-type (:nev-block/type nev-block)
                                               :nev-block  nev-block
                                               :view-args  view-args})))
             (doall))]
       [:div {:style {:height "400px"}}])]))
